//httpConfig.interceptor.ts
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, catchError, map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../services/auth/auth.service';
import { Router } from '@angular/router';
import { CoreService } from '../core.service';
import { ErrorMessageService } from '../error-message.service';

@Injectable({ providedIn: 'root' })
export class HttpConfigInterceptor implements HttpInterceptor {
  token$ = this.authService.token$;

  constructor(
    private readonly authService: AuthService,
    private coreservice: CoreService,
    private errorMessageService: ErrorMessageService,
    private readonly router: Router
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Skip interceptor entirely when using mock data
    if (environment.useMock) {
      return next.handle(request);
    }

    if (!request.url.includes(`${environment.apiUrl}/v1`)) {
      return next.handle(request);
    }

    request = request.clone({
      setHeaders: { AppVersion: environment.appVersion },
    });

    let tkn;
    let token = localStorage.getItem('token');
    if (token) tkn = JSON.parse(token);
    if (tkn) {
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${tkn}` },
      });
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        console.log(error);
        if (error?.status === 404) {
          this.showError(error?.error?.Message ?? '');
          return throwError(() => new Error('404'));
        }
        if (error?.status === 401) {
          this.authService.logout();
          if (this.router.url === '/login') this.showError(error?.error ?? '');
          return throwError(() => new Error('Αποτυχία σύνδεσης'));
        }
        this.showError(error?.error);
        const body = error?.error;
        const message =
          (typeof body === 'object' && body !== null && (body.message ?? body.Message)) ??
          (typeof body === 'string' ? body : null) ??
          body?.errorCode ??
          body?.ErrorCode ??
          'Unknown error';
        return throwError(() => new Error(message));
      })
    );
  }

  showError(error: any) {
    this.coreservice.showError(this.errorMessageService.getErrorMessage(error));
  }
}
